import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import StatTile from '../../../components/common/StatTile';

const UserOnTimeReportingTile = () => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getUserOnTimeReporting } = DashboardApis();

  useEffect(() => {
    getUserOnTimeReporting()
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getUserOnTimeReporting]);

  return (
    <StatTile
      label="On Time Reporting"
      value={value !== null ? value.toFixed(2) : '-'}
      suffix="%"
      loading={loading}
      error={error}
    />
  );
};

export default UserOnTimeReportingTile;